import { useTranslations } from '@vocab/react';
import { Box, Stack, Text, TextLinkButton } from 'braid-design-system';
import { useCallback } from 'react';

import translations from '../.vocab/';
import { useGetResetCandidateChatContext } from '../hooks/candidateChatContextHelpers';
import { useCareerFeedAIAssistant } from '../hooks/useCareerFeedAIAssistant';

export const CareerFeedAIAssistantEmptyState = () => {
  const { t } = useTranslations(translations);
  const {
    tracking: { trackGenAIChatResetPressed },
  } = useCareerFeedAIAssistant();
  const resetPreferences = useGetResetCandidateChatContext();
  const onReset = useCallback(() => {
    trackGenAIChatResetPressed('home recs');
    resetPreferences();
  }, [resetPreferences, trackGenAIChatResetPressed]);

  return (
    <Box paddingY="large">
      <Stack space="medium">
        <Stack space="small">
          <Text size="large" weight="strong">
            {t('No jobs match your answers right now')}
          </Text>
          <Text>
            {t('Come back later to check if any new jobs have been posted...')}
          </Text>
        </Stack>
        <Text weight="medium">
          <TextLinkButton onClick={onReset}>
            {t('Try different answers')}
          </TextLinkButton>
        </Text>
      </Stack>
    </Box>
  );
};
